var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.token)?_c('div',{staticClass:"admin_page"},[_c('div',{staticClass:"wrapper"},[_c('navi-bar'),_c('slider',{attrs:{"slide-menu-items":_vm.slideMenuItems}}),_c('content-wrap'),_c('modal'),_c('confirmation-modal')],1)]):_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }